import {bookActionType} from '../../constants';

export default (state = 0, action) => {
    switch (action.type) {
        case bookActionType.SET_TOTAL_RECORDS:
            return action.payload;
        default:
            return state;
    }
}
